import React from 'react';
import {View, Preloader} from 'MWC';
import mainTpl from '../../templates/orderAction/main';
import FormModel from '../../models/form.m';
import PropTypes from 'prop-types';

export default class extends View {
    templates = {
        [this.uiStates.INTERACTIVE]: mainTpl,
        [this.uiStates.PROCESSING]: mainTpl,
        [this.uiStates.INITIAL]: <div />,
        [this.uiStates.STANDBY]: (
            <div className='module-carts-main'>
                <Preloader />
            </div>
        )
    };

    constructor(props) {
        super(props);

        this.formModel = new FormModel();

        this.state = {
            ui: this.uiStates.INITIAL
        };
    }

    static defaultProps = {
        row: false
    };

    static propTypes = {
        row: PropTypes.bool
    };

    static displayName = 'Cards.Views.Order';
}
